(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aveline-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Keep the bag count fresh after AJAX cart updates.
  function sync() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-av-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
        });
      })
      .catch(function () {});
  }
  document.addEventListener('cart:updated', sync);
  document.addEventListener('cart:refresh', sync);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aveline-product-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*amount\s*\}\}/, v)
                   .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
                   .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','));
    }
    return '$' + v;
  }

  function initHero(root) {
    if (!root || root.dataset.avInit === '1') return;
    root.dataset.avInit = '1';

    var dataEl = root.querySelector('[data-av-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    var fmt = root.dataset.moneyFormat || '';
    var discount = parseFloat(root.dataset.bundleDiscount || '0');
    var idInput = root.querySelector('[data-av-variant-id]');
    var priceEl = root.querySelector('[data-av-price]');
    var instalEl = root.querySelector('[data-av-instal]');
    var ctaPrice = root.querySelector('[data-av-cta-price]');
    var ctaBtn = root.querySelector('[data-av-cta]');
    var ctaLabel = root.querySelector('[data-av-cta-label]');
    var stickyMeta = root.querySelector('[data-av-sticky-meta]');
    var stickyPrice = root.querySelector('[data-av-sticky-price]');
    var bundleNote = root.querySelector('[data-av-bundle-note]');
    var skuEl = root.querySelector('[data-av-sku]');

    function selectedOptions() {
      var out = [];
      root.querySelectorAll('[data-av-option]:checked').forEach(function (i) {
        out[parseInt(i.dataset.avOptionIndex, 10)] = i.value;
      });
      return out;
    }

    function currentQty() {
      var q = root.querySelector('[data-av-bundle]:checked');
      return q ? parseInt(q.dataset.avQty, 10) : 1;
    }

    function match(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== undefined && v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function paintChoiceStates() {
      root.querySelectorAll('.av-swatch, .av-size, .av-bundle').forEach(function (el) {
        var input = el.querySelector('input');
        if (input) el.classList.toggle('is-on', input.checked);
      });
    }

    function update() {
      var opts = selectedOptions();
      var v = match(opts);
      paintChoiceStates();

      var shadeOut = root.querySelector('[data-av-selected-shade]');
      var shadeLbl = root.querySelector('[data-av-shade-label]');

      root.querySelectorAll('[data-av-option]:checked').forEach(function (i) {
        var f = i.closest('[data-av-option-index]');
        if (!f) return;
        var legendShade = f.querySelector('[data-av-selected-shade]');
        var legendSize = f.querySelector('[data-av-selected-size]');
        if (legendShade) legendShade.textContent = i.value;
        if (legendSize) legendSize.textContent = i.value;
      });
      if (shadeLbl && shadeOut) shadeLbl.textContent = shadeOut.textContent;

      var qty = currentQty();
      if (bundleNote) bundleNote.hidden = !(qty === 2 && discount > 0);

      if (!v) {
        if (ctaBtn) { ctaBtn.disabled = true; }
        if (ctaLabel) ctaLabel.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = v.id;
      if (skuEl) skuEl.textContent = v.sku || '—';

      var unit = v.price;
      var total = qty === 2 ? Math.round(unit * 2 * (1 - discount / 100)) : unit;

      if (priceEl) priceEl.textContent = money(unit, fmt);
      if (instalEl) instalEl.textContent = money(Math.round(unit / 4), fmt);

      var b1 = root.querySelector('[data-av-bundle-price="1"]');
      var b2 = root.querySelector('[data-av-bundle-price="2"]');
      if (b1) b1.textContent = money(unit, fmt);
      if (b2) b2.textContent = money(Math.round(unit * 2 * (1 - discount / 100)), fmt);

      if (ctaBtn) ctaBtn.disabled = !v.available;
      if (v.available) {
        if (ctaPrice) ctaPrice.textContent = money(total, fmt);
        else if (ctaLabel) ctaLabel.textContent = 'Add to bag — ' + money(total, fmt);
      } else if (ctaLabel) {
        ctaLabel.textContent = 'Sold out';
      }

      if (stickyMeta) stickyMeta.textContent = v.title + ' · ' + money(total, fmt);
      if (stickyPrice) stickyPrice.textContent = money(total, fmt);

      var design = window.Shopify && window.Shopify.designMode;
      if (window.history && window.history.replaceState && !design) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-av-option], [data-av-bundle]')) update();
    });

    var mainImg = root.querySelector('[data-av-zoom]');
    root.querySelectorAll('[data-av-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        root.querySelectorAll('[data-av-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (mainImg && t.dataset.avSrc) mainImg.src = t.dataset.avSrc;
      });
    });

    var frame = root.querySelector('[data-av-parallax]');
    if (frame && mainImg) {
      frame.addEventListener('mouseenter', function () { mainImg.style.transform = 'scale(1.07)'; });
      frame.addEventListener('mouseleave', function () { mainImg.style.transform = 'none'; });
    }

    var counter = root.querySelector('[data-av-count]');
    if (counter) {
      var target = parseInt(counter.dataset.avCountTo, 10) || 0;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        counter.textContent = target.toLocaleString();
      } else {
        var t0 = performance.now();
        var tick = function () {
          var p = Math.min(1, (performance.now() - t0) / 1600);
          var e = 1 - Math.pow(1 - p, 3);
          counter.textContent = Math.round(target * e).toLocaleString();
          if (p < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }
    }

    var sticky = root.querySelector('[data-av-sticky]');
    if (sticky) {
      var onScroll = function () {
        var on = window.scrollY > 700;
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      root._avScroll = onScroll;
      onScroll();
    }

    update();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-av-hero]').forEach(initHero);
  }

  document.addEventListener('DOMContentLoaded', function () { boot(); });
  boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-av-hero]');
    if (root && root._avScroll) window.removeEventListener('scroll', root._avScroll);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aveline-reveal"] && !Shopify.designMode) return;
  try {
    
(function () {
  var io = null;
  function observer() {
    if (io) return io;
    if (!('IntersectionObserver' in window)) return null;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    return io;
  }

  function sweep(scope) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var o = observer();
    (scope || document).querySelectorAll('.av-rv').forEach(function (el) {
      if (el.dataset.avRv === '1') return;
      el.dataset.avRv = '1';
      if (reduce || !o) { el.classList.add('is-in'); return; }
      o.observe(el);
    });
    setTimeout(function () {
      (scope || document).querySelectorAll('.av-rv:not(.is-in)').forEach(function (el) {
        el.classList.add('is-in');
      });
    }, 6000);
  }

  document.addEventListener('DOMContentLoaded', function () { sweep(); });
  sweep();
  document.addEventListener('shopify:section:load', function (e) { sweep(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aveline-transformation"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.avInit === '1') return;
    root.dataset.avInit = '1';
    root.querySelectorAll('[data-av-slider]').forEach(function (s) {
      var range = s.querySelector('[data-av-range]');
      if (!range) return;
      var apply = function () { s.style.setProperty('--av-pct', range.value + '%'); };
      range.addEventListener('input', apply);
      apply();
    });
  }
  function boot(scope) { (scope || document).querySelectorAll('[data-av-tf]').forEach(init); }
  document.addEventListener('DOMContentLoaded', function () { boot(); });
  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
